import { cn } from '@exam-room/utils';

interface FlatSpinnerIconProps {
  className?: string;
}

export default function FlatSpinnerIcon(props: Readonly<FlatSpinnerIconProps>) {
  const { className = '' } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='84'
      height='84'
      viewBox='0 0 84 84'
      fill='none'
      className={cn(
        'fill-primary m-auto h-6 max-h-full w-6 max-w-full animate-spin text-gray-200',
        className,
      )}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M58.6669 13.1322C52.3122 9.46331 44.9244 7.99379 37.6493 8.95157C30.3743 9.90935 23.6186 13.2409 18.43 18.4295C13.2414 23.6181 9.90983 30.3738 8.95206 37.6489C7.99428 44.9239 9.46381 52.3117 13.1327 58.6664C16.8016 65.0211 22.4649 69.9877 29.2441 72.7957C36.0234 75.6038 43.5397 76.0964 50.6275 74.1973C57.7153 72.2981 63.9784 68.1133 68.4453 62.2918C72.9123 56.4703 75.3335 49.3375 75.3335 41.9997C75.3335 39.6985 77.199 37.8331 79.5002 37.8331C81.8014 37.8331 83.6669 39.6985 83.6669 41.9997C83.6669 51.172 80.6403 60.0879 75.0566 67.3648C69.4729 74.6416 61.6441 79.8727 52.7843 82.2466C43.9246 84.6206 34.5291 84.0048 26.0551 80.4947C17.581 76.9846 10.502 70.7765 5.91583 62.8331C1.3297 54.8897 -0.507201 45.6549 0.690019 36.5611C1.88724 27.4674 6.05167 19.0227 12.5374 12.537C19.0232 6.05119 27.4678 1.88675 36.5616 0.689531C45.6554 -0.50769 54.8901 1.32921 62.8335 5.91534C64.8264 7.06593 65.5092 9.61423 64.3587 11.6071C63.2081 13.6 60.6598 14.2828 58.6669 13.1322Z'
        fill='currentFill'
      />
    </svg>
  );
}
